import React, { Component } from "react"
import { Card, CardBody, Col, Media, Row } from "reactstrap"

class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <Card>
                                {/* Render Email Top Tool Bar */}
                                <CardBody>
                                    

                                    <h4 className="mt-0 font-size-16"> Welcome to the bloXmove community app! </h4>
                                    <p>
                                        So glad you could make it. Validate your NFT in the Validate NFT tab to continue to the KYC and community token pre-sale process.
                                    </p>
                                    
                                    <hr />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default Dashboard
